import React from 'react';

import Helmet from 'react-helmet';

export default () => (
  <Helmet title="Office Space Calculator: Find out how much space you need">
    <meta
      name="description"
      content="Our office space calculator makes it easy to determine how much space you need. View recommended spaces and seamlessly manage your office space search using the SquareFoot platform."
    />
    <meta name="og:title" content="Office Space Calculator" />
    <meta name="og:type" content="website" />
    <meta
      name="og:url"
      content="https://www.squarefoot.com/office-space-calculator"
    />
    <meta name="og:image" content={require('./Tools.png')} />
    <meta property="og:image:secure_url" content={require('./Tools.png')} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
  </Helmet>
);
